<template>
  <div class="Evaluate">
            <el-dialog
                :visible.sync="dialogVisible"
                width="456px"
                :before-close="handleClose">
                <p class="name">快为本门课程打个分吧！</p>
                <el-rate class="evaluaye-number" :allow-half="true" v-model="evaluate"></el-rate>
                <!-- <p class="evaluaye-number">
                    <span class="txt">评价指数：</span>
                    <span class="icon" v-for="item in 5" :key="item" :class="{'active': item <= evaluate }" @click="evaluateNumber(item)"></span>
                  
                </p> -->
                <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="说说你对该课程的看法吧…"
                    maxlength="90"
                    show-word-limit
                    v-model="comment">
                </el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="uploadCourseComment()">立即评价</el-button>
                </span>
            </el-dialog>
        </div>   
         <!-- 课程评价弹窗 -->
</template>

<script>
import {mapActions} from 'vuex'
import {uploadCourseComment} from 'api/course'
export default {
    name: 'Evaluate',
    data() {
        return {
            dialogVisible: false, // 弹窗
            comment: '',    // 评论
            evaluate: 5,   // 评价
            courseid: '',
        }
    },
    mounted() {},
    methods: {
        uploadCourseComment() {

            if (this.evaluate == 0) {
                this.$message.error('评价指数不能为空');
            } else if (this.comment == "") {
                this.$message.error('评价内容不能为空');
            } else {
                this.setLoading(true)
                uploadCourseComment({
                    data: {courseid: this.courseid, evaluatecount: this.evaluate, content: this.comment},
                    success: data => {
                        this.setLoading(false)
                        if (data.code == '000') {

                            this.$message.success('评价成功')
                            this.comment = ''
                            
                            this.$emit('evaluateSuccess')

                        } else {
                            this.comment = ''
                            this.$message.error(data.msg)
                        }
                        this.dialogVisible = false
                    },
                    error: data => {
                        this.comment = ''
                        this.$message.error(data.msg)
                        this.setLoading(false)
                        this.dialogVisible = false
                    }
                })
            }
        },
        startPopu(courseid) {
            this.evaluate = 5
            this.courseid = courseid
            this.dialogVisible = true
        },
        handleClose() {
            // this.evaluate = 0
            this.comment = ''
            this.dialogVisible = false
        },
        evaluateNumber(num) {
            this.evaluate = num
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
    
}
</script>

<style lang="scss" type="text/scss" scope> 
.Evaluate {
   
    .name {
        font-size: 14px;
        color: #333;
    }
    .el-dialog__footer {
        text-align: center;
    }
    .evaluaye-number {
        margin-top: 15px;
        font-size: 12px;
        color: #333;
        margin-bottom: 15px;
        span {
            display: inline-block;
        }
        .txt {
            transform: translateY(-5px);
            -webkit-transform: translateY(-5px);
            -moz-transform: translateY(-5px);
            -ms-transform: translateY(-5px);
            -o-transform: translateY(-5px);
        }
        .icon {
            margin-left: 8px;
            width: 20px;
            height: 20px;
            background: url('../../../../common/images/catalog/icon-evaluate.png') no-repeat 100%;
            background-size: 20px;
            cursor: pointer;

            &.active {
                background: url('../../../../common/images/catalog/icon-evaluate-true.png') no-repeat 100%;
                background-size: 20px;
            }
        }
    }
}
</style>